import axios from "axios";


export const getDebtorInfo = (params: any) => {
  const requestParams = params.queryKey[1];
  return axios.get(`/debtors/${requestParams.id}`, {params: {projectId: requestParams.projectId}})
}
